var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMouth3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 14,
    viewBox: "0 0 60 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_100_5839)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.7826 13.6905C13.7322 13.6905 1.3148 4.13221 0.793057 3.73569C-0.104334 3.02612 -0.271291 1.71134 0.438274 0.813949C1.14784 -0.0834427 2.46262 -0.271269 3.36001 0.438296C3.48523 0.521775 15.1931 9.51656 30.7826 9.51656C46.3722 9.51656 56.4313 0.626123 56.5357 0.521775C57.3913 -0.250399 58.7061 -0.166921 59.4783 0.688731C60.2504 1.54438 60.167 2.85917 59.3113 3.63134C58.8522 4.04873 47.9165 13.6696 30.7826 13.6696V13.6905Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_100_5839"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 13.6904,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMouth3);
export default __webpack_public_path__ + "static/media/mouth-3.21207788c08ada6ec5ff3c3a9ee14657.svg";
export { ForwardRef as ReactComponent };